module.exports = __webpack_public_path__ + "img/logo.4dd97962.png";